export default "__VITE_ASSET__CYV0cVax__"